<template>
  <v-sheet tile color="white" class="fill-height">
    <v-container align="center">
      <v-row justify="center">
        <v-col cols="12" lg="4" class="brand-add">

          <PhotoPicker v-model='imagePath' v-bind:photoPickerConfig="imagePickerConfig"/>
          <span class="upload-logo-text">Please upload brand logo. Recommended resolution is 60x60 px.</span>

          <v-text-field filled background-color="#F4F7FC" required
                        :rules="[v => !!v || 'Brand name is required']"
                        type="text" class="pt-6"
                        v-model="brand_name" label="Brand Name" name="brand_name"/>
          <v-text-field filled background-color="#F4F7FC" required
                        :rules="[v => !!v || 'Security Role Title is required']"
                        type="text"
                        v-model="security_role_title" label="Security Role Title" name="security_role_title"/>
          <v-text-field filled background-color="#F4F7FC" required
                        :rules="[v => !!v || 'Store Manager Role Title is required']"
                        type="text"
                        v-model="store_manager_role_title" label="Store Manager Role Title"
                        name="store_manager_role_title"/>
          <v-btn :loading="loadingState" :disabled="!readyToSubmit" text color="white" @click="createBrand" class="fixed-btn">Add</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
  import PhotoPicker from "./PhotoPicker";
  import {createBrand} from "../graphql/mutations";
  import {process_api_error} from "@/utils/utils"
  import {PAGE_IDS} from "../utils/constants"
 import {mapGetters} from "vuex";
  export default {
    name: "BrandAdd",
    components: {PhotoPicker},
    data: function () {
      return {
        security_role_title: 'Store Security',
        store_manager_role_title: 'Store Manager',
        brand_name: '',
        imagePath: '',
      }
    },
    methods: {
      createBrand() {
        this.$store.dispatch('startLoading')
        this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(createBrand, {
          input: {
            name: this.brand_name,
            image: this.imagePath,
            brandmanagers: [],
            security_role_title: 'Security',
            store_manager_role_title: 'Store Manager',
          }
        }))
          .then((res) => {
            this.$store.dispatch('stopLoading')
            this.$store.dispatch('addBrand', res.data.createBrand)
            this.$router.push({name: PAGE_IDS.BRANDS_LIST})
          })
          .catch((e) => {
             this.$store.dispatch('stopLoading')
            process_api_error(`Error Creating Brand`, e)
          });
      }
    },
    computed: {
         ...mapGetters([ 'loadingState']),
      readyToSubmit() {
        return this.brand_name && this.security_role_title && this.store_manager_role_title
      },
      imagePickerConfig() {
        var ts = Date.now()
        return {
          header: 'Upload Brand Logo',
          accept: 'image/*',
          path: `brands_logos/${ts}/`,
          defaultName: 'brand_logo',
          level: 'public'
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .brand-add {
    text-align: center;

    .upload-logo-text {
      color: var(--v-primary-base);
    }
  }
</style>



// WEBPACK FOOTER //
// src/Brands/BrandAdd.vue